import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import '../styles/layout.css';
import '../styles/dark-theme.css';
import '../styles/light-theme.css';
import { useApi } from '../Context/ApiContext';
import useApiRequests from '../hooks/useApiRequests';
import { useNotification } from '../hooks/useNotification';
import { useCookies } from "react-cookie";
import IconMaker from './IconMaker/IconMaker';
import { Header } from './Header/Header';
import { useTheme } from '../Context/ThemeContext';
import AppLogo from '../assets/images/Logo.svg';
import TLogo from '../assets/images/T.svg';
import { shouldRenderComponent } from '../Utils/routeUtils';


const Layout = ({ children }) => {
  const [activeRoute, setActiveRoute] = useState(window.location.pathname);
  const [alreadyRequested, setAlreadyRequested] = useState(false);
  const [notifications, setNotifications] = useState();
  const [expandedSubmenus, setExpandedSubmenus] = useState({});
  const [currentMember, setCurrentMember] = useState(null);

  const { theme, toggleTheme } = useTheme();

  const [isMenuCollapsed, setIsMenuCollapsed] = useState(true);
  const [removeCookie] = useCookies(['token']);

  const location = useLocation();
  const navigate = useNavigate();
  const { isUnauthorized, menuData, setMenuData, showSidebar, setShowSidebar } = useApi();
  const { notify } = useNotification();
  const { getMenuData, getMyNotifications, currentMemberCanScreeaning, getCurrentMember } = useApiRequests();

  const shouldRender = shouldRenderComponent(['/code', '/signin', '/signup']);

  useEffect(() => {
    if (localStorage.getItem("menu") != null && localStorage.getItem("menu" != undefined)) {
      const localStorageMenu = JSON.parse(localStorage.getItem("menu"));
      setMenuData(localStorageMenu);
    }

    if (!isUnauthorized) {
      if (!alreadyRequested) {
        if (!location.pathname.startsWith("/authenticate") && location.pathname != "/code" && !location.pathname.includes("/task/aval")) {

          if (sessionStorage.getItem("canScreening") == undefined && sessionStorage.getItem("canScreening") == null) {
            const fetchData = async () => {
              const data = await currentMemberCanScreeaning();
              if (data != null && data.success) {
                sessionStorage.setItem("canScreening", data.data);
              }
            };
            fetchData();
          }

          const fetchData = async () => {
            const data = await getMenuData();
            setMenuData(data.data.menu);
            localStorage.setItem("menu", JSON.stringify(data.data.menu));
            if (data.msg != null && data.msg != "") {
              notify(data.msg, { type: "alert" });
            }
          };

          const fetchCurrentUser = async () => {
            try {
              const data = await getCurrentMember();
              if (data.success) {
                setCurrentMember(data.data);
              }
            } catch (error) {
              console.log('Error fetching current member:', error);
            }
          };

          fetchData();
          fetchCurrentUser();
        }
      }
    }

  }, [alreadyRequested])

  const isRouteActive = (routeName) => {
    // Exact match for root route
    if (routeName === '/' && location.pathname === '/') {
      return true;
    }
    
    // Exact match for other routes (not root)
    if (routeName !== '/' && location.pathname === routeName) {
      return true;
    }
    
    return false;
  };

  const isSubmenuParentActive = (submenuItems) => {
    if (!submenuItems || submenuItems.length === 0) return false;
    
    return submenuItems.some(subItem => 
      location.pathname === subItem.route
    );
  };

  const handleLogout = () => {
    var dataDeExpiracao = new Date();
    dataDeExpiracao.setFullYear(dataDeExpiracao.getFullYear() - 1);

    var cookieString = 'token' + "=; expires=" + dataDeExpiracao.toUTCString() + "; path=/";

    document.cookie = cookieString;
    localStorage.removeItem("menu");
    window.location.href = "/code";
  };

  const toggleSubmenu = (index) => {
    setExpandedSubmenus(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleMenuItemClick = (route) => {
    setActiveRoute(route);
    navigate(route);
  };

  const handleUserClick = () => {
    navigate('/profile');
  };

  useEffect(() => {
    if (location.pathname != "/signin" && location.pathname != "/signup" && location.pathname != "/code" && !location.pathname.startsWith("/authenticate") && !location.pathname.includes("aval")) {
      const fetchNotifications = async () => {
        const data = await getMyNotifications();
        if (data.success) {
          if (data.data != null || data.data != undefined) {
            setNotifications({
              new: data.data.new || [],
              old: data.data.old || []
            });
          }

        } else {
          notify(data.msg, { type: "error" });
        }
      }
      fetchNotifications();
    }
  }, [])

  useEffect(() => {
    if (location.pathname == "/signin" || location.pathname == "/signup" || location.pathname == "/code" || location.pathname.startsWith("/authenticate") || location.pathname.includes("/task/aval")) {
      setShowSidebar(false);
    }
    
    if (isUnauthorized && (window.location.pathname != "/signin" && window.location.pathname != "/signup" && location.pathname != "/code" && location.pathname.startsWith("/authenticate") && location.pathname.includes("/task/aval"))) {
      window.location.href = "/code";
    }
  }, [location]);

  useEffect(() => {
    const fetchNotifications = async () => {
      const data = await getMyNotifications();
      if (data.success) {
        if (data.data != null || data.data != undefined) {
          setNotifications({
            new: data.data.new || [],
            old: data.data.old || []
          });
        }

      } else {
        notify(data.msg, { type: "error" });
      }
    }
    const intervalId = setInterval(fetchNotifications, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    // Auto-expand submenus when sidebar is expanded and there's an active submenu item
    if (!isMenuCollapsed && menuData) {
      menuData.forEach((item, index) => {
        if (item.submenu && item.submenu.length > 0) {
          const hasActiveSubitem = item.submenu.some(subItem => 
            location.pathname === subItem.route
          );
          if (hasActiveSubitem && !expandedSubmenus[index]) {
            setExpandedSubmenus(prev => ({
              ...prev,
              [index]: true
            }));
          }
        }
      });
    }
  }, [isMenuCollapsed, location.pathname, menuData]);

  // HARDCODE: Force dark mode on every render
  useEffect(() => {
    localStorage.setItem('mode', 'dark');
    document.body.id = 'dark';
  }, []);

  return (
    <div id="dark" style={{ display: 'flex', minHeight: '100vh' }}>

      {showSidebar && location.pathname != "/signin" && location.pathname != "/signup" && location.pathname != "/code" && !location.pathname.startsWith("/authenticate") && !location.pathname.includes("aval") &&
        <div 
          className={`custom-sidebar ${isMenuCollapsed ? 'collapsed' : ''}`}
          style={{
            width: isMenuCollapsed ? '80px' : '300px',
            height: '100vh',
            position: 'sticky',
            top: '0',
            zIndex: 1000,
            transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
          onMouseEnter={() => setIsMenuCollapsed(false)}
          onMouseLeave={() => setIsMenuCollapsed(true)}
        >
          {/* Logo */}
          <div className='custom-logo'>
            {isMenuCollapsed ?
              <img src={TLogo} alt='Dev Tracker App Logo' style={{ width: '36px', height: '36px' }} />
              :
              <img src={AppLogo} alt='Dev Tracker App Logo' style={{ maxWidth: '160px', height: 'auto' }} />
            }
          </div>

          {/* User Section */}
          {currentMember && (
            <div className={`user-section ${isMenuCollapsed ? 'collapsed' : ''}`} onClick={handleUserClick}>
              <div className="user-avatar">
                {currentMember.fullName ? currentMember.fullName.charAt(0).toUpperCase() : '?'}
              </div>
              {!isMenuCollapsed && (
                <div className="user-info">
                  <div className="user-name">{currentMember.fullName || 'Usuário'}</div>
                  <div className="user-role">{currentMember.email || 'Clique para ver perfil'}</div>
                </div>
              )}
            </div>
          )}

          {/* Menu Items */}
          <div className="custom-menu">
            {menuData != null && menuData.map((item, index) => {
              const isActive = isRouteActive(item.route);
              const hasSubmenu = item.submenu && item.submenu.length > 0;
              const isExpanded = expandedSubmenus[index];
              const isSubmenuActive = hasSubmenu && isSubmenuParentActive(item.submenu);

              return (
                <div key={index} className="custom-menu-item">
                  <div 
                    className={`custom-menu-button ${isActive ? 'active' : ''} ${isSubmenuActive ? 'submenu-parent-active' : ''}`}
                    onClick={() => {
                      if (hasSubmenu) {
                        if (!isMenuCollapsed) {
                          toggleSubmenu(index);
                        }
                      } else {
                        handleMenuItemClick(item.route);
                      }
                    }}
                  >
                    <div className="custom-menu-icon">
                      {IconMaker(item.icon, false)}
                    </div>
                    {!isMenuCollapsed && (
                      <>
                        <span className="custom-menu-label">{item.label}</span>
                        {hasSubmenu && (
                          <div className={`custom-submenu-arrow ${isExpanded ? 'expanded' : ''}`}>
                            ▶
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {/* Submenu */}
                  {hasSubmenu && !isMenuCollapsed && (
                    <div className={`custom-submenu ${isExpanded ? 'expanded' : ''}`}>
                      {item.submenu.map((subItem, subIndex) => {
                        const isSubActive = isRouteActive(subItem.route);
                        return (
                          <div 
                            key={subIndex}
                            className={`custom-submenu-item ${isSubActive ? 'active' : ''}`}
                            onClick={() => handleMenuItemClick(subItem.route)}
                          >
                            <span className="custom-submenu-label">{subItem.label}</span>
                            {subItem.totalCount !== "" && subItem.totalCount !== "0" && (
                              <span className="custom-badge">
                                {subItem.totalCount}
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}

            {/* Divider */}
            {!isMenuCollapsed && <div className="custom-divider" />}

            {/* Logout Button */}
            <div className="custom-menu-item">
              <div 
                className="custom-menu-button"
                onClick={handleLogout}
              >
                <div className="custom-menu-icon">
                  {IconMaker("BiSolidLogOut")}
                </div>
                {!isMenuCollapsed && (
                  <span className="custom-menu-label">Sair</span>
                )}
              </div>
            </div>
          </div>
        </div>
      }

      <div style={{ 
        width: '100%', 
        minHeight: '100vh',
        backgroundColor: '#22272b', // Always dark background
        transition: 'all 0.3s ease'
      }}>
        {showSidebar && location.pathname != "/signin" && location.pathname != "/signup" && location.pathname != "/code" && !location.pathname.startsWith("/authenticate") && !location.pathname.includes("aval") &&
          notifications ? <Header notifications={notifications} /> : <div style={{ height: shouldRender ? "68px" : "0px" }} ></div>
        }
        <div style={{ 
          marginLeft: shouldRender ? "2rem" : "0rem",
          marginRight: shouldRender ? "2rem" : "0rem",
          paddingTop: shouldRender ? "1rem" : "0rem"
        }}>
          {children}
        </div>
      </div>

      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
};

export default Layout;
